//// Application Configuration

//// Application Packages

//// Application Slices

//// Application Components

//// Carbon Components

//// Carbon Icons

//// Static Constants

// Extract Submission Data (Utility)
export const extractSubmissionForm = async (digital_name, formsData) => {
    try {
        if (digital_name && formsData) {
            const names = Object?.keys(formsData)
            const forms = Object?.values(formsData)
            if (names?.length > 0 && forms?.length > 0) {
                const index = names?.indexOf(digital_name)
                if (index > -1) {
                    const form = forms[index]
                    if (form?.values) {
                        return form.values
                    }
                }
            }
        }
    } catch (error) {
        console.warn('Extract Submission Form Error:', error)
        return null
    }
}

// Extract Submissiosn Data (Utility)
export const extractSubmissionsForm = async (
    digital_name,
    formsData,
    sub_forms
) => {
    try {
        const submissions = []
        if (digital_name && sub_forms && formsData) {
            const form = formsData?.[digital_name]
            if (form) {
                if (sub_forms?.length > 0) {
                    sub_forms.forEach((el) => {
                        const subForm = form?.[el]
                        if (subForm) {
                            const subFormValues = subForm?.['values']
                            if (subFormValues) {
                                submissions.push(subFormValues)
                            } else {
                                submissions.push({})
                            }
                        }
                    })
                }
            }
        }
        return submissions
    } catch (error) {
        console.warn('Submissions Error:', error)
        return null
    }
}

// Subtract Additional Values - Array (Utility)
export const subtractValuesAdditionalArrayForm = (
    fields,
    max_form_iterations,
    values,
    index
) => {
    try {
        if (fields && max_form_iterations && values && index > -1) {
            // Check In Result Variable
            const saved = []

            // Extract Keys & Values
            const valueKeys = Object?.keys(values)
            const valueValues = Object?.values(values)

            // Check For Submitted Keys & Values
            if (valueKeys?.length > 0 && valueValues?.length > 0) {
                // Check In Operation Variable
                const temp = { ...values }
                const check = {}

                valueKeys.forEach((valueKey) => {
                    // Check Fields Configuration For Key (Part Of Original Form)
                    const fullCharCheck = fields?.[valueKey]
                    const maxFormIteration =
                        max_form_iterations?.[index].toString()

                    // Extract Last Character Of Array
                    const lastVarChar = valueKey?.slice(-1).toString()

                    // Check Last Character Is Within Max Form Iterations
                    const lastVarCharCheck =
                        max_form_iterations?.indexOf(lastVarChar)

                    // Extract Last Two Characters Of Array
                    const lastTwoVarChar = valueKey?.slice(-2).toString()

                    // Check Last Two Characters Are Within Max Form Iterations
                    const lastTwoVarCharCheck =
                        max_form_iterations?.indexOf(lastTwoVarChar)

                    // Set Array Index With Actual Number Value
                    const actualIndex = index + 1

                    // Set Actual Index String Value
                    const actualIndexString = actualIndex.toString()

                    if (fullCharCheck) {
                        check.one = true
                    } else {
                        check.one = false
                    }

                    if (
                        lastVarChar === maxFormIteration &&
                        lastVarCharCheck > -1 &&
                        lastVarChar !== actualIndexString
                    ) {
                        check.two = true
                    } else {
                        check.two = false
                    }

                    if (
                        lastTwoVarChar === maxFormIteration &&
                        lastTwoVarCharCheck > -1 &&
                        lastVarChar !== actualIndexString
                    ) {
                        check.three = true
                    } else {
                        check.three = false
                    }

                    // Check For No Reasons To Save
                    if (
                        !check?.['one'] &&
                        !check?.['two'] &&
                        !check?.['three']
                    ) {
                        delete temp[valueKey]
                    }
                })

                saved.push(temp)
            }

            // Check For Saved Object
            if (saved?.length > 0) {
                return saved?.[0]
            } else {
                return {}
            }
        } else {
            return values
        }
    } catch (error) {
        console.warn('Subtract Form Values Error:', error)
        return null
    }
}

// Subtract Additional Values - Boolean (Utility)
export const subtractValuesAdditionalBooleanForm = (auxiliary, values) => {
    try {
        if (auxiliary && values) {
            // Check In Result Variable
            const saved = []

            // Extract Keys & Values
            const valueKeys = Object?.keys(values)
            const valueValues = Object?.values(values)

            // Check For Submitted Keys & Values
            if (valueKeys?.length > 0 && valueValues?.length > 0) {
                // Check In Operation Variable
                const temp = { ...values }

                valueKeys.forEach((valueKey) => {
                    // Extract Last Two Characters Of Array
                    const lastTwoVarChar = valueKey?.slice(-2).toString()

                    // Check For No Reasons To Save
                    if (
                        (lastTwoVarChar === 'PL' &&
                            auxiliary?.['practice_location'] === false) ||
                        (lastTwoVarChar === 'SL' &&
                            auxiliary?.['satellite_location'] === false)
                    ) {
                        delete temp[valueKey]
                    }
                })

                saved.push(temp)
            } else {
                // Check In Operation Variable
                const temp = { ...values }
                saved.push(temp)
            }

            // Check For Saved Object
            if (saved?.length > 0) {
                return saved?.[0]
            } else {
                return {}
            }
        } else {
            return values
        }
    } catch (error) {
        console.warn('Subtract Form Values Error:', error)
        return null
    }
}

// Subtract Conditional Values - Radio (Utility)
export const subtractValuesAdditionalConditionalForm = (
    conditions,
    values,
    key,
    value
) => {
    try {
        if (conditions && values && key && value) {
            // Check In Result Variable
            const saved = []

            // Extract Keys & Values
            const valueKeys = Object?.keys(values)
            const valueValues = Object?.values(values)
            const conditional = conditions?.[key]

            // Check For Submitted Conditions, Keys & Values
            if (value === 'N' && conditional === 'DELETE_ALL_FIELDS') {
                // Check In Operation Variable
                const temp = {}
                temp[key] = value
                saved.push(temp)
            } else if (
                value === 'N' &&
                valueKeys?.length > 0 &&
                valueValues?.length > 0 &&
                conditional?.length > 0
            ) {
                // Check In Operation Variable
                const temp = { ...values, [key]: value }

                valueKeys.forEach((valueKey) => {
                    // Check For Index Of Condition In Conditionals
                    const conditionKeyIndex = conditional?.indexOf(valueKey)

                    // Check For No Reasons To Save
                    if (conditionKeyIndex > -1) {
                        delete temp[valueKey]
                    }
                })

                saved.push(temp)
            } else {
                // Check In Operation Variable
                const temp = { ...values, [key]: value }
                saved.push(temp)
            }

            // Check For Saved Object
            if (saved?.length > 0) {
                return saved?.[0]
            } else {
                return {}
            }
        } else {
            return values
        }
    } catch (error) {
        console.warn('Subtract Form Values Error:', error)
        return null
    }
}
